/**
 * @description Represents the configuration settings for feature flags in both development and production environments.
 *
 * @property {boolean} dev - Indicates if the feature flag is enabled in the development environment.
 * @property {boolean} prod - Indicates if the feature flag is enabled in the production environment.
 */
const AppConfig = {
  calendly: {
    dev: true,
    prod: true,
  },

  googleTagManager: {
    dev: false,
    prod: true,
  },
  hubspot: {
    dev: false,
    prod: true,
  },
  linkedinInsights: {
    dev: false,
    prod: true,
  },
  recaptcha: {
    dev: true,
    prod: true,
  },
  segment: {
    dev: false,
    prod: true,
  },
  // Pack integrations.sentry is the source of truth (default false). Alta pack = true.
  sentry: {
    dev: false,
    prod: true,
  },
  singpass: {
    dev: true,
    prod: true,
  },
  discordGiveaway0323: {
    dev: true,
    prod: true,
  },
  ecf: {
    dev: true,
    prod: true,
  },
  hardcodeHamiltonHoldings: {
    dev: true,
    prod: true,
  },
  marketingOptIn: {
    dev: true,
    prod: true,
  },
  pricingGraph: {
    dev: true,
    prod: true,
  },
  paymentRef: {
    dev: true,
    prod: true,
  },
  portfolio: {
    dev: true,
    prod: true,
  },
  primaryFirmDeal: {
    dev: true,
    prod: true,
  },
  raiseCapital: {
    dev: true,
    prod: true,
  },
  topPicks: {
    dev: true,
    prod: true,
  },
  mmf: {
    dev: true,
    prod: true,
  },
  singpassNoa: {
    dev: true,
    prod: true,
  },
  idenfy: {
    dev: true,
    prod: true,
  },
  partner: {
    dev: true,
    prod: true,
  },
};

export default AppConfig;
